import { render } from "./NotificationPrompt.vue?vue&type=template&id=7015b6ce&scoped=true"
import script from "./NotificationPrompt.vue?vue&type=script&lang=js"
export * from "./NotificationPrompt.vue?vue&type=script&lang=js"

import "./NotificationPrompt.vue?vue&type=style&index=0&id=7015b6ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7015b6ce"]])

export default __exports__